import axios from '@/assets/js/axios'
import Urls from '@/assets/js/Urls'
/**
 * 创建评论
 * @param {{topicId: number, parentCommentId: number, content: string}} params
 * @return {*}
 */
export function createComments(params) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Comments/Comments/CreateComments`,
    method: 'post',
    data: params
  })
    .then(data => {
      return data
    })
    .catch(() => null)
}

/**
 * 获取评论列表
 * @param topicId
 * @return {*}
 */
export function getComments(topicId) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Comments/Comments/GetComments`,
    method: 'post',
    data: {
      topicId
    }
  })
    .then(data => data)
    .catch(() => null)
}

/**
 * 获取子评论
 * 分页获取直接评论下的所有子评论(子评论的下级评论也全部加载)
 * @param commentId
 * @return {*}
 */
export function getSubComments(commentId) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Comments/Comments/GetSubComments`,
    method: 'post',
    data: {
      commentId
    }
  })
    .then(data => (data.result.code === 0 ? data.detail.list : []))
    .catch(() => null)
}
export function deleteComment(commentId) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Comments/Comments/DeleteComment`,
    method: 'post',
    data: { commentId: commentId }
  })
}
